var PortafoliosDataGrid;
(function (PortafoliosDataGrid) {
    class CopyGrid {
        constructor(_dotNetObj, _containerId) {
            this.dotNetObject = null;
            this.dotNetObject = _dotNetObj;
            this.containerId = _containerId;
            this.containerElement = document.getElementById(_containerId);
            this.inicializar();
        }
        inicializar() {
            var _a, _b;
            this.handleOnCopyRef = (e) => this.setHandleOnCopy(e);
            this.handleKeyDownRef = (e) => this.setKeyDown(e);
            this.handleKeyUpRef = (e) => this.setKeyUp(e);
            this.activeHandlerRef = () => this.setActive();
            (_a = this.containerElement) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', this.activeHandlerRef);
            (_b = this.containerElement) === null || _b === void 0 ? void 0 : _b.addEventListener('focusin', this.activeHandlerRef);
            document.addEventListener('copy', this.handleOnCopyRef);
            document.body.addEventListener('keydown', this.handleKeyDownRef);
            document.body.addEventListener('keyup', this.handleKeyUpRef);
        }
        setActive() {
            CopyGrid.ActiveContainerId = this.containerId;
            let st = window.ST;
            if (st && typeof st.clearActiveGrid === 'function') {
                st.clearActiveGrid();
            }
        }
        isActive() {
            return CopyGrid.ActiveContainerId === this.containerId;
        }
        setHandleOnCopy(e) {
            let st = window.ST;
            if (Utils.isEditableElement(e.target) ||
                (st && typeof st.hasActiveGrid === 'function' && st.hasActiveGrid()) ||
                !this.isActive()) {
                return;
            }
            this.dotNetObject.invokeMethodAsync('HandleOnCopy');
        }
        setKeyDown(e) {
            if (!this.isActive() || this.isTextEditingElement(e.target)) {
                return;
            }
            if ([37, 38, 39, 40].indexOf(e.which) >= 0) {
                e.preventDefault();
                this.dotNetObject.invokeMethodAsync('NavegarCeldaSeleccionada', e.which);
            }
        }
        setKeyUp(e) {
            if (this.isActive() && e.which == 27) {
                console.log('Escape detectado');
                this.dotNetObject.invokeMethodAsync('LimpiarSeleccion');
            }
        }
        isTextEditingElement(target) {
            let element = target;
            if (element instanceof HTMLSelectElement) {
                return true;
            }
            if (!Utils.isEditableElement(element)) {
                return false;
            }
            return !(element instanceof HTMLInputElement &&
                (element.type == 'checkbox' || element.type == 'radio'));
        }
        scrollToCell(_rowId, _visibleRowIndex, _column) {
            let scrollCellIntoView = () => {
                let cells = this.containerElement.querySelectorAll('td[data-rowid][data-col]');
                let cell = Array.from(cells).find(element => element.getAttribute('data-rowid') == _rowId &&
                    element.getAttribute('data-col') == _column);
                if (!cell) {
                    return false;
                }
                let containerRect = this.containerElement.getBoundingClientRect();
                let header = this.containerElement.querySelector('thead');
                let visibleTop = (header === null || header === void 0 ? void 0 : header.getBoundingClientRect().bottom) || containerRect.top;
                let cellRect = cell.getBoundingClientRect();
                if (cellRect.top < visibleTop) {
                    this.containerElement.scrollTop -= visibleTop - cellRect.top;
                }
                else if (cellRect.bottom > containerRect.bottom) {
                    this.containerElement.scrollTop += cellRect.bottom - containerRect.bottom;
                }
                if (cellRect.left < containerRect.left) {
                    this.containerElement.scrollLeft -= containerRect.left - cellRect.left;
                }
                else if (cellRect.right > containerRect.right) {
                    this.containerElement.scrollLeft += cellRect.right - containerRect.right;
                }
                let booleanInput = cell.querySelector('input[type="checkbox"]:not([disabled]), input[type="radio"]:not([disabled])');
                if (booleanInput) {
                    booleanInput.focus({ preventScroll: true });
                }
                else {
                    this.containerElement.focus({ preventScroll: true });
                }
                return true;
            };
            if (scrollCellIntoView()) {
                return;
            }
            let renderedRow = this.containerElement.querySelector('tbody tr');
            let rowHeight = (renderedRow === null || renderedRow === void 0 ? void 0 : renderedRow.getBoundingClientRect().height) || 27;
            this.containerElement.scrollTop = _visibleRowIndex * rowHeight;
            requestAnimationFrame(() => requestAnimationFrame(scrollCellIntoView));
        }
        setClipboardRows(_rows, _head) {
            var table = document.createElement('table');
            if (_head && _head.length > 0) {
                var thead = document.createElement('thead');
                for (var i = 0; i < _head.length; i++) {
                    var th = document.createElement('th');
                    th.style.fontWeight = 'bold';
                    th.style.backgroundColor = '#CCCCCC';
                    th.innerText = _head[i].title;
                    thead.appendChild(th);
                }
                table.appendChild(thead);
            }
            if (_rows && _rows.length > 0) {
                var tbody = document.createElement('tbody');
                var tbodyFragment = document.createDocumentFragment();
                for (var i = 0; i < _rows.length; i++) {
                    var tr = document.createElement('tr');
                    for (var j = 0; j < _rows[i].cells.length; j++) {
                        var td = document.createElement('td');
                        this.formatCellAsText(td, _rows[i].cells[j].isText);
                        td.innerText = _rows[i].cells[j].value;
                        tr.appendChild(td);
                    }
                    tbodyFragment.append(tr);
                }
                tbody.append(tbodyFragment);
                table.appendChild(tbody);
            }
            var html = table.outerHTML;
            var blob = new Blob([html], { type: "text/html" });
            navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
        }
        setClipboardText(_text, _isText) {
            if (_isText) {
                this.setClipboardRows([{ cells: [{ value: _text, isText: true }] }], null);
                return;
            }
            navigator.clipboard.writeText(_text);
        }
        formatCellAsText(_cell, _isText) {
            if (!_isText) {
                return;
            }
            _cell.setAttribute('style', 'mso-number-format:"\\@";');
            _cell.setAttribute('x:str', '');
        }
        dispose() {
            var _a, _b;
            (_a = this.containerElement) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousedown', this.activeHandlerRef);
            (_b = this.containerElement) === null || _b === void 0 ? void 0 : _b.removeEventListener('focusin', this.activeHandlerRef);
            document.removeEventListener('copy', this.handleOnCopyRef);
            document.body.removeEventListener('keydown', this.handleKeyDownRef);
            document.body.removeEventListener('keyup', this.handleKeyUpRef);
        }
        static crearInstancia(_dotNetObj, _containerId) {
            let htmlEl = document.getElementById(_containerId);
            if (!htmlEl) {
                return;
            }
            let found = CopyGrid.CurrentInstances.filter(a => a.containerId == _containerId);
            if (found.length > 0) {
                let arrIndex = CopyGrid.CurrentInstances.indexOf(found[0]);
                found[0].dispose();
                delete found[0];
                CopyGrid.CurrentInstances.splice(arrIndex, 1);
            }
            let newInstance = new CopyGrid(_dotNetObj, _containerId);
            CopyGrid.CurrentInstances.push(newInstance);
            return newInstance;
        }
    }
    CopyGrid.CurrentInstances = [];
    CopyGrid.ActiveContainerId = null;
    PortafoliosDataGrid.CopyGrid = CopyGrid;
})(PortafoliosDataGrid || (PortafoliosDataGrid = {}));
